"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), {}, {
    children: (0, _jsxRuntime.jsx)("path", {
      d: "M31.808 16.616h-4.299c.102 1.03.854 1.36 1.707 1.36.875 0 1.579-.197 2.16-.507v1.771a4.443 4.443 0 01-2.432.587c-2.139 0-3.643-1.334-3.643-3.99 0-2.234 1.275-4.01 3.36-4.01 2.091 0 3.179 1.749 3.179 4 0 .213-.021.672-.032.789zm-3.157-2.997c-.55 0-1.158.389-1.158 1.376h2.267c0-.987-.57-1.376-1.11-1.376zm-6.811 6.208c-.768 0-1.237-.32-1.547-.555l-.01 2.47-2.198.463V11.971h2.006l.042.544a2.507 2.507 0 011.723-.688c1.547 0 2.997 1.386 2.997 3.946 0 2.79-1.44 4.054-3.013 4.054zm-.507-6.054c-.506 0-.821.182-1.05.432l.01 3.264c.214.235.523.416 1.04.416.811 0 1.355-.88 1.355-2.064 0-1.146-.555-2.048-1.355-2.048zm-6.272-1.802h2.203v7.701h-2.203v-7.701zm0-2.507L17.264 9v1.792l-2.203.47V9.463zm-2.304 4.987v5.221H10.56v-7.701h1.973l.064.65c.534-.944 1.638-.752 1.931-.65v2.021c-.277-.09-1.221-.23-1.77.459zm-4.56 2.517c0 1.296 1.387.896 1.664.779v1.792c-.293.16-.821.288-1.541.288a2.213 2.213 0 01-2.277-2.262l.005-7.024 2.144-.458v1.888h1.675v1.882h-1.67v3.12-.005zm-2.618.373c0 1.584-1.232 2.486-3.056 2.486-.819-.001-1.628-.17-2.379-.496v-2.096c.736.4 1.653.698 2.379.698.49 0 .816-.128.816-.533 0-1.056-3.339-.661-3.339-3.093 0-1.552 1.216-2.48 2.997-2.48.726 0 1.451.106 2.182.4v2.069a4.923 4.923 0 00-2.187-.565c-.459 0-.768.133-.768.48 0 .986 3.355.517 3.355 3.136v-.006z",
      fill: "#000",
      fillRule: "evenodd"
    })
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Stripe.js.map